import { ca } from '@cian/analytics';

import { TJsonQuery } from '../../../packages/JsonQuery';

export const trackMapShow = ({ jsonQuery }: { jsonQuery: TJsonQuery }) => {
  ca('eventSite', {
    event: 'newpage',
    name: 'newpage',
    category: 'page',
    action: 'newpage',
    label: 'open',
    page: {
      pageType: 'Map',
      siteType: 'mobile',
    },
    sc: jsonQuery,
  });
};
